exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-component-embedded[data-v-3de2ce02]{width:100%;height:800px}.report-container[data-v-3de2ce02]{height:100%}", ""]);

// exports
